export const CATEGORY_SHOW_RESET = 'CATEGORY_SHOW_RESET'
export const CATEGORY_SHOW_SET_ERROR = 'CATEGORY_SHOW_SET_ERROR'
export const CATEGORY_SHOW_SET_RETRIEVED = 'CATEGORY_SHOW_SET_RETRIEVED'
export const CATEGORY_SHOW_TOGGLE_LOADING = 'CATEGORY_SHOW_TOGGLE_LOADING'
